import { loadStripe } from "@stripe/stripe-js";

const initializeStripe = async () => {
  const stripePromise = await loadStripe("pk_live_51ByFhNCVk5hnoOYcQBj9Wcj2XeggvzxWoLw5SzkWnw0nTBtTTvTCaXVX1WeypVbG9GR9cpH7uKBfX0xhjTsFolAW00Ly7eRhp7");

  return stripePromise;
};
export default initializeStripe;
